import React, { useEffect, useId, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { marketingHomeUrl } from '../i18n';
import '../css/Login.css';

export default function AuthCard({ title, children, busy = false }) {
  const { t, i18n } = useTranslation();
  const id = useId();
  const card = useRef(null);
  const outsidePress = useRef(false);
  const close = () => window.location.assign(marketingHomeUrl(i18n.language));
  useEffect(() => {
    const previous = document.activeElement;
    card.current?.focus();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, []);
  const onKeyDown = event => {
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key !== 'Tab') return;
    const nodes = [...card.current.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), [tabindex="0"]')];
    const first = nodes[0]; const last = nodes[nodes.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === card.current)) {
      event.preventDefault(); last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  };
  return <main className="auth-overlay"
    onPointerDown={event => { outsidePress.current = event.target === event.currentTarget; }}
    onClick={event => { if (outsidePress.current && event.target === event.currentTarget) close(); outsidePress.current = false; }}>
    <section className="auth-card" role="dialog" aria-modal="true" aria-labelledby={id} aria-busy={busy} tabIndex={-1} ref={card} onKeyDown={onKeyDown}>
      <button type="button" className="auth-close" aria-label={t('authModern.close')} onClick={close}><span aria-hidden="true">×</span></button>
      <div className="auth-art"><img src="/flipped_doctor_image.webp" alt="" /></div>
      <div className="auth-body"><h1 id={id}>{title}</h1>{children}</div>
    </section>
  </main>;
}

export function GoogleButton({ onClick, disabled, label }) {
  const { t } = useTranslation();
  return <button type="button" className="auth-google" disabled={disabled} onClick={onClick}>
    <span className="auth-google-icon"><img src="/google-g.png" alt="" /></span>
    <span>{label || t('authModern.google')}</span>
  </button>;
}
